/* eslint-disable no-unused-vars */
import qs from "qs";
import http from "../http";

function filternonnull(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
}

function getFilterData(payload) {
  return http(
    "GET",
    `${window.API_URL}/project/internal-name-filters?${qs.stringify(
      filternonnull(payload)
    )}`
  );
}

function getUserList(payload) {
  return http(
    "GET",
    `${window.API_URL}/admin/users?${qs.stringify(filternonnull(payload))}`
  );
}

function getUserListExcel(payload) {
  return http(
    "GET",
    `${window.API_URL}/admin/users/download?${qs.stringify(
      filternonnull(payload)
    )}`,
    payload,
    {},
    { responseType: "blob" }
  );
}

function getPaymentList(payload) {
  return http(
    "GET",
    `${window.API_URL}/admin/payments?${qs.stringify(filternonnull(payload))}`
  );
}

function getPaymentListExcel(payload) {
  return http(
    "GET",
    `${window.API_URL}/admin/payments/download?${qs.stringify(
      filternonnull(payload)
    )}`,
    payload,
    {},
    { responseType: "blob" }
  );
}

function getPaymentDetailListExcel(payload) {
  return http(
    "GET",
    `${window.API_URL}/admin/payment/${payload.id}/download`,
    {},
    { responseType: "blob" }
  );
}

function deleteUser(payload) {
  return http("DELETE", `${window.API_URL}/admin/user?userIdList=${payload}`);
}

function createUser(payload) {
  return http("POST", `${window.API_URL}/admin/user`, payload);
}

function resetUserPassword(payload) {
  return http(
    "PATCH",
    `${window.API_URL}/admin/user/pw-reset?userIdList=${payload}`
  );
}
function setPaymentStatus(payload) {
  const { paymentIdList, status } = payload;
  return http(
    "PATCH",
    `${window.API_URL}/admin/payment/status?paymentIdList=${paymentIdList}&status=${status}`
  );
}
function setPaymentDate(payload) {
  const { paymentIdList, amountDate } = payload;
  return http(
    "PATCH",
    `${window.API_URL}/admin/payment/amount_date?paymentIdList=${paymentIdList}&amountDate=${amountDate}`
  );
}

export default {
  getFilterData,
  getUserList,
  getUserListExcel,
  getPaymentList,
  getPaymentListExcel,
  getPaymentDetailListExcel,
  deleteUser,
  createUser,
  resetUserPassword,
  setPaymentStatus,
  setPaymentDate,
};
